import {Component, OnInit, ViewChild} from '@angular/core';
import { Router } from '@angular/router';
import { MessageService} from 'primeng/api';
import { HttpErrorResponse } from '@angular/common/http';
import { FormService } from '../../services/form.service'
import { PreDocument } from '../../types/pre-document'
import { Document } from '../../types/document'
import { NgForm } from "@angular/forms";
import {Constants} from "../../types/constants";

@Component({
  selector: 'app-choose-form',
  templateUrl: './choose-form.component.html',
  styleUrls: ['./choose-form.component.css']
})
export class ChooseFormComponent implements OnInit {

  @ViewChild('chooseForm') chooseForm!: NgForm;

  preDocument !: PreDocument;
  document !: Document;
  blockUI : boolean = false;
  
  constructor(
    private formService: FormService,
    private router: Router,
    private messageService: MessageService) {}

  ngOnInit(): void {
    //this.document = this.formService.document;
    this.preDocument = this.formService.preDocument;
    this.preDocument.documentTypeId = "REGISTRATION";
    this.preDocument.registerTypeId = "RPK";
  }

  showProposalsList() {
    this.router.navigate(['/proposals-list']);
  }

  createForm(): void {
    this.formService.preDocument = this.preDocument;
    let message:string = '';
    if (!this.preDocument.companyTypeId)
      message = "Wybierz rodzaj podmiotu";
    else {
      if (this.chooseForm == undefined)
        message = Constants.GenericError;
      else {
        if (this.preDocument.companyTypeId == "OF_P_1") {
          let nip = this.chooseForm.form.controls['nip'];
          if (nip == undefined || nip.invalid) {
            this.chooseForm.form.markAllAsTouched();
            return;
          }
        } else {
          let krs = this.chooseForm.form.controls['krs'];
          if (krs == undefined || krs.invalid) {
            this.chooseForm.form.markAllAsTouched();
            return;
          }
        }
      }
    }
    if (!this.preDocument.registerTypeId)
      message = "Wybierz typ rejestru";
    if (!this.preDocument.documentTypeId)
      message = "Wybierz rodzaj wniosku";

    if (message) {
      this.messageService.add({
        severity:'warn',
        detail:message}
      );
      return;
    }

    this.blockUI = true;
      
    this.formService.getCompanyData(this.preDocument)
      .subscribe(
        response => {
          this.blockUI = false;
          if (response.body != null) {
            this.document = response.body;
            if (!this.document.company.contactData)
              this.document.company.contactData = {};
            if (!this.document.company.proxy)
              this.document.company.proxy = {};
            this.formService.document = this.document;
            this.router.navigate(['/rpk']);
          }
        },
        (error: HttpErrorResponse) => {
          this.blockUI = false;

          this.messageService.add({
             severity: (error.status == 400 && error.error.message != Constants.GenericError) ? 'warn' : 'error',
             detail: error.error.message ?? Constants.GenericError,
             life: (error.status == 400 && error.error.message != Constants.GenericError) ? 6000 : 3000}
          );
        }
      );
    
    
  }
  
}
